import { Box, Typography } from '@mui/material';

import type { NormalizedModuleItem, SelectionKey } from '../../types/merge-customization';

import { PatientColumn } from './PatientColumn';

export type PatientModuleData = Record<string, Record<string, NormalizedModuleItem[]>>;

export interface PatientColumnInfo {
  id: string;
  name: string;
  isPrimary: boolean;
}

interface PatientColumnLayoutProps {
  patients: PatientColumnInfo[];
  patientModuleData: PatientModuleData;
  selections: Set<SelectionKey>;
  onToggleItem: (key: SelectionKey) => void;
  isDuplicate: (key: SelectionKey) => boolean;
  patientColors: Map<string, string>;
  onSelectAllFromPatient: (patientId: string) => void;
  onDeselectAllFromPatient: (patientId: string) => void;
}

export function PatientColumnLayout({
  patients,
  patientModuleData,
  selections,
  onToggleItem,
  isDuplicate,
  patientColors,
  onSelectAllFromPatient,
  onDeselectAllFromPatient,
}: PatientColumnLayoutProps) {
  if (patients.length === 0) {
    return (
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="body1" color="text.secondary">
          No patient data available.
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        overflowX: 'auto',
        alignItems: 'flex-start',
        pb: 1,
      }}
    >
      {patients.map((patient, index) => (
        <PatientColumn
          key={patient.id}
          patientId={patient.id}
          patientName={patient.name}
          isPrimary={patient.isPrimary}
          moduleData={patientModuleData[patient.id] ?? {}}
          selections={selections}
          onToggleItem={onToggleItem}
          isDuplicate={isDuplicate}
          patientColor={patientColors.get(patient.id) ?? '#888'}
          patientIndex={index}
          onSelectAll={() => onSelectAllFromPatient(patient.id)}
          onDeselectAll={() => onDeselectAllFromPatient(patient.id)}
        />
      ))}
    </Box>
  );
}
